import React, { useEffect } from 'react';
import { BrowserRouter, Route, Routes, useNavigate } from 'react-router-dom';
import { Auth0Provider, withAuthenticationRequired, useAuth0 } from '@auth0/auth0-react'; // Import the Auth0 hook
import HomePage from './HomePage';
import Header from "./Header";
import Chat from "./Chat";
import logo from './logo.svg';
import './App.css';
import ReactGA from "react-ga4";

const ProtectedRoute = ({ component, ...args }) => {
  const Component = withAuthenticationRequired(component, args);
  return <Component />;
};

const Auth0ProviderWithRedirectCallback = ({ children, ...props }) => {
  const navigate = useNavigate();
  const onRedirectCallback = (appState) => {
    navigate((appState && appState.returnTo) || window.location.pathname);
  };
  return (
    <Auth0Provider onRedirectCallback={onRedirectCallback} {...props}>
      {children}
    </Auth0Provider>
  );
};

export default function App() {

  return (
    <BrowserRouter>
      <Auth0ProviderWithRedirectCallback
      domain="aiccc.us.auth0.com"
      clientId="lx0CkX3j0RJS9sdmPvFTpgv3KLJWglfU"
        authorizationParams={{
          redirect_uri: window.location.origin,
          audience: "https://aiccc.us.auth0.com/api/v2/",
          scope: "openid profile email"
        }}
      >
        <HeaderWrapper />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route
            path="/chat"
            element={<ProtectedRoute component={Chat} />}
          />
          <Route
            path="/chat/:threadId"
            element={<ProtectedRoute component={Chat} />}
          />
        </Routes>
      </Auth0ProviderWithRedirectCallback>
    </BrowserRouter>
  );
}

const HeaderWrapper = () => {
  const { isAuthenticated, loginWithRedirect } = useAuth0();
  return <Header isAuthenticated={isAuthenticated} loginWithRedirect={loginWithRedirect} />;
};